import { Config } from '../config/param';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ParamDiversService {

    constructor(private http: HttpClient) {}

    getParamByTable(table: string) {
        return this.http.post(`${Config.API_URL}/param_divers/get_by_table_param`, { table_param: table });
    }
}
